<template>
  <div id="app">
    <v-app id>
      <v-navigation-drawer fixed v-model="drawer" app>
        <v-list dense>
          <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.link">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-content>{{ item.title }}</v-list-tile-content>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="indigo" dark fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="text-xs-center nav-title">Royal Experience</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="userId">
          <v-btn
            flat
            @click="route_option"
          >
            <i class="material-icons">{{navBarOption}}</i>
          </v-btn>
          <v-btn
            flat
            @click="$router.push('/shopping-cart')"
          >
            <i class="material-icons">shopping_cart</i>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container class="pa-3" fluid fill-height >
          <v-layout>
            <v-fade-transition mode="out-in">
              <router-view/>
            </v-fade-transition>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer color="indigo" app>
        <div class="f-container">
          <img class="copy-spacing" src="./assets/logo.png" alt="" height="15" width="auto">
          <span class="white--text copy-spacing">&copy; {{ year }}</span>
          <span class="white--text">Royal Experience, LLC</span>
        </div>
      </v-footer>
      <snackbar/>
    </v-app>
  </div>
</template>

<script>
// Utilities
import { mapState } from "vuex";

// Components
import Snackbar from "./components/snackbar";

export default {
  name: "app",
  components: { Snackbar },
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    year: new Date().getFullYear(),
    navBarOption: null,
    navBarRoute: null
  }),
  computed: {
    ...mapState(['userId','user']),
    menuItems () {

      let navBarOption
      let navBarRoute
  
      let menuItems = [
        { icon: 'portrait', title: 'Sign In', link: '/' },
        { icon: 'create', title: 'Sign Up', link: '/sign-up' },
      ]
      if (this.userId) {
        if (this.user.general.type === 'individual' || this.user.general.type === 'business') {
          menuItems = [
            { icon: 'home', title: 'Home', link: '/home' },
            { icon: 'person', title: 'Profile', link: '/profile' },
            { icon: 'assignment_ind', title: 'Setup', link: '/setup' },
            { icon: 'import_contacts', title: 'Quick Guide', link: '/home' },
            // { icon: 'local_offer', title: 'Experience Packages', link: '/events' },
            // { icon: 'share', title: 'Experience Services', link: '/events' },
            { icon: 'local_library', title: 'Booked Experiences', link: '/events' },
            { icon: 'add', title: 'Create Experience', link: '/create-event' },
            { icon: "shopping_cart", title: "Shopping Cart", link: "/shopping-cart" },
            { icon: "favorite", title: "Customer Service", link: "/customer-service" },
            { icon: 'logout', title: 'Sign Out', link: '/sign-out' }
          ]
          this.navBarOption = 'event_available'
          this.navBarRoute = 'create-event'
        } else {
          menuItems = [
            { icon: 'person', title: 'Setup', link: '/setup' },
            { icon: 'logout', title: 'Sign Out', link: '/sign-out' }
          ]
          this.navBarOption = 'group_add'
          this.navBarRoute = 'setup'
        }
      } else {
        menuItems = [
          { icon: 'logout', title: 'Sign In', link: '/' },
          { icon: 'create', title: 'Sign Up', link: '/sign-up' }
        ]
      }

      let isAdmin = this.$store.getters.isAdmin;
      if (isAdmin)
        menuItems.unshift({ icon: "verified_user", title: "Admin", link: "/admin" });

      return menuItems
    },
     
  },
  methods: {
    route_option () {
      if(this.navBarRoute === 'setup'){
        this.$router.push('setup')
      }
      if(this.navBarRoute === 'create-event'){
        this.$router.push('create-event')
      }
    }, 
    goSignin () {
      this.$router.push('/')
    },
    goSignup () {
      this.$router.push('sign-up')
    } 
  }
};
</script>

<style>
.f-container {
  padding: 0 5px;
  width: fit-content;
  height: fit-content;
}

.copy-spacing {
  margin: auto 5px auto 0;
  vertical-align: middle;
}

.nav-title {
  font-size: 16px !important;
  margin-left: 25px !important;
}

hr {
  margin: 20px 0;
}
</style>
